<template>
    <div class="portals-table">
        <table class="table header-table is-narrow">
            <thead>
            <tr>
                <th
                    :key="header"
                    v-for="header in tableHeader"
                >
                    {{ $t(`${header}`) }}
                </th>
            </tr>
            </thead>
            <tbody>
            <template>
                <tr
                    :key="p.portal.id"
                    v-for="p in portals"
                >
                    <td>
                        <img
                            v-if="p.portal.logo_thumb"
                            class="portals-table__logo" :src="p.portal.logo_thumb"
                            :alt="`${p.portal.name} Logo`"
                        >
                        <img
                            v-else-if="p.portal.logo"
                            class="portals-table__logo" :src="p.portal.logo"
                            :alt="`${p.portal.name} Logo`"
                        >
                        <i v-else class="fa fa-picture-o portals-table__logo" aria-hidden="true"/>
                    </td>
                    <td>{{ p.portal.name }}</td>
                    <td><i aria-hidden="true" class="fa fa-check-circle is-valid"
                           v-if="p.portal.default || p.portal.cnc_booking_funnel"/>
                    </td>

                    <td
                        v-if="p.portal.campground_info.active"
                        :title="formatAsText(p.portal.campground_info.members_info)">
                        {{ p.portal.campground_info.members_info.total }} / {{ p.portal.campground_info.members_info.active || 0 }}
                    </td>
                    <td v-else>-</td>
                    <td><i aria-hidden="true" class="fa fa-check-circle is-valid"
                           v-if="p.portal.campground_info.active"/>
                        <i aria-hidden="true"
                           class="fa fa-minus-circle is-invalid"
                           v-else></i>

                    </td>
                    <td>{{ p.portal.campground_info.commission }}</td>
                    <td>{{ getProvisionIncludedText(p.portal.campground_info.include_changer_commission) }}</td>
                    <td class="portals__table-edit">
                        <i
                            class="fa fa-pencil-square-o fa-lg pointer"
                            aria-hidden="true"
                            @click="edit(p.portal)"
                        />
                    </td>
                </tr>
            </template>
            </tbody>
        </table>

        <EditPortal
            v-if="showModal"
            :campsites="campsites"
            :portal-prop="editingPortal"
            :portal-members="portalMembers"
            :documents-accepted="documentsAccepted"
            @close="toggleModal"
            @update="updatePortal"
        />
    </div>
</template>

<script>
import EditPortal from './editPortal.vue';
import PortalMembersTable from './portalMembersTable.vue';

export default {
    name: 'portalsTable',
    components: {
        EditPortal,
        PortalMembersTable,
    },
    props: {
        documentsAccepted: Boolean,
        campsites: Array,
        portals: Array,
        portalMembers: Array,
        getPortalName: Function,
    },
    data() {
        return {
            showModal: false,
            editingPortal: null,
            tableHeader: [
                'generic.logo',
                'portals.table.portal',
                'portals.table.default',
                'portals.table.count',
                'portals.table.active',
                'portals.table.provision',
                'portals.table.cnc',
                'portals.table.edit',
            ],
        };
    },
    methods: {
        edit(portal) {
            this.toggleModal();
            this.editingPortal = portal;
        },
        formatAsText(obj) {
            if(!obj) return '';
            return Object.entries(obj)
                .map(([key, value]) => `${key}: ${value}`)
                .join('\n');
        },
        toggleModal() {
            this.showModal = !this.showModal;
        },
        updatePortal() {
            this.$emit('update');
        },
        getProvisionIncludedText(isIncluded) {
            return isIncluded ? this.$t('generic.yes') : this.$t('generic.no');
        }
    },
};
</script>

<style lang="scss" scoped>
.portals-table {
    &__logo {
        width: 4rem;
        height: 4rem;
        font-size: 3.5rem;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/components/portals/portalsTable.vue